export default "__VITE_ASSET__BJv8WDKh__"